import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ExternalFundDocument } from '../../Models/Models/Documents/InstructionDocuments/ExternalFundDocument';
import { ExternalDocumentType } from '../../Models/Domains/Documents/ExternalDocumentType';

declare var IS_RUNNING_IN_APP_POOL;

export class ExternalFundDocumentClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(accountInstructionId: number, customerId: number, company: string, externalDocumentType: ExternalDocumentType, instrumentCodes: Array<string>): Promise<ExternalFundDocument, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Documents/ExternalFundDocument/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { accountInstructionId: accountInstructionId, customerId: customerId, company: company, externalDocumentType: externalDocumentType, instrumentCodes: instrumentCodes }

    return AjaxWrapper.get<ExternalFundDocument, any>(url, data);
  }
}

